// extracted by mini-css-extract-plugin
module.exports = {"container":"_1u2392eQCQsuWuFUBaL6Qt","heading":"UeYXEH-sIj2Yo75PHvCue","buttons":"_2SNoxqdaplsyOhooXDwnmd"};